import React from 'react'

import ReactMarkdown, { type Options } from 'react-markdown'

import ComponentErrorBoundary from '@/components/error/ComponentErrorBoundary'

import { removeMarkdownFormatting } from '@/helpers/string'

export interface MarkdownProps extends Options {
  logError?: boolean
}

const Markdown: React.FC<MarkdownProps> = ({
  children,
  className,
  logError = true,
  ...props
}) => {
  const fallback = (
    <span className={className ?? ''}>
      {removeMarkdownFormatting(children ?? '')}
    </span>
  )
  return (
    <ComponentErrorBoundary fallback={fallback} logError={logError}>
      <ReactMarkdown className={className} {...props}>
        {children}
      </ReactMarkdown>
    </ComponentErrorBoundary>
  )
}

export default Markdown
